import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Dropdown from "react-bootstrap/Dropdown";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { RiHandCoinLine } from "react-icons/ri";
import { FaCubes } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";

import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosInstance } from "../../../axiosInstance";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend
// );
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  Title,
  Tooltip,
  Legend,
);

function createData2(
  date,
  source,
  countryParty,
  invoice,
  ordervalue,
  paid,
  balaceAmount,
  status,
  actions,
) {
  return {
    date,
    source,
    countryParty,
    invoice,
    ordervalue,
    paid,
    balaceAmount,
    status,
    actions,
  };
}

const rows2 = [
  createData2(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Pending",
  ),
  createData2(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Paid",
  ),
  createData2(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Overdue",
  ),
];

export const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dashboardCards, setDashboardCards] = useState({});
  const [chartData, setChartData] = useState([]);
  //filters
  const [show, setShow] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");

  async function FetchChartData() {
    try {
      setLoading(true);
      const config = {
        params: {
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "/dashboard/distributor/cards-summary-view/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setDashboardCards(response.data.data);
        setChartData(response.data.data.results?.[0] ?? []);
        console.log("Fetched chart data successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch chart and card data",
      );
      console.log("Failed to fetch chart and card data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchChartData();
  }, [selectedLabel]);
  const [orderList, setOrderList] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  //   const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
  };

  async function FetchOrdersList() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get("/distributor/orders/", config);
      if (response.data.status === "success" || response.status === 200) {
        setOrderList(response.data?.data);
        setTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch order list");
      console.log("Failed to fetch order list");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchOrdersList();
  }, [page, rowsPerPage, selectedLabel]);

  const [lowPage, setLowPage] = useState(0);
  const [lowRowsPerPage, setLowRowsPerPage] = useState(5);
  const [lowTotalCount, setLowTotalCount] = useState(0);

  const handleLowRowsPerPage = (event) => {
    setLowRowsPerPage(+event.target.value);
    setLowPage(0);
  };
  const [lowStockProducts, setlowStockProducts] = useState({});
  async function FetchLowStockProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: lowPage + 1,
          page_size: lowRowsPerPage,
          date: selectedLabel,
        },
      };

      const response = await axiosInstance.get(
        "/inventory/distributor/product-low-stock/",
        config,
      );

      if (response.data.status === "Success" || response.status === 200) {
        setlowStockProducts(response.data.data);
        setLowTotalCount(response.data.data.count);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch Low Stock products",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchLowStockProducts();
  }, [lowPage, lowRowsPerPage, selectedLabel]);

  // fast moving products
  const [fastMovingData, setFastMovingData] = useState([]);
  async function LoadFastMovingProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "/dashboard/distributor/fast-moving-products/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setFastMovingData(response.data?.data);
        console.log("Fast moving products data fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to load fast moving products",
      );
      console.log("Failed to load fast moving products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    LoadFastMovingProducts();
  }, [selectedLabel]);

  const handleClearFilters = () => {
    setSelectedLabel("");
  };

  const themeColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-theme")
    .trim();
  const data = {
    labels: chartData?.map((item) => item.date),
    datasets: [
      {
        type: "bar",
        label: "Sales Value (₹)",
        data: chartData?.map((item) => item.total_amount),
        backgroundColor: themeColor,
        borderColor: themeColor,
        borderWidth: 1,
        yAxisID: "y", // left axis
        barPercentage: 0.4,
        categoryPercentage: 0.6,
      },
      {
        type: "line",
        label: "Orders Count",
        data: chartData?.map((item) => item.order_count),
        borderColor: "#10B981",
        backgroundColor: "#10B981",
        yAxisID: "y1", // right axis
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: "#10B981",
        pointBorderColor: "#fff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          padding: 15,
        },
      },
      tooltip: {
        usePointStyle: true,
        callbacks: {
          label: (context) => {
            if (context.dataset.label === "Sales Value (₹)") {
              return `Sales: ₹${context.formattedValue}`;
            }
            return `Orders: ${context.formattedValue}`;
          },
        },
      },
    },
    scales: {
      y: {
        type: "linear",
        position: "left",
        ticks: {
          callback: (value) => new Intl.NumberFormat("en-IN").format(value),
        },
        grid: {
          drawOnChartArea: true,
        },
      },
      y1: {
        type: "linear",
        position: "right",
        grid: {
          drawOnChartArea: false, // no grid lines for right axis
        },
        ticks: {
          stepSize: 5,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="dashboardContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div className="dasboardTitle">
              <div>Dashboard</div>
              <div>
                Real-time overview of stock, orders, POS sales, and payments.
              </div>
            </div>
            {/* <div>
              <Dropdown>
                <Dropdown.Toggle
                  className="btnDropdownMonth"
                  id="dropdown-basic"
                >
                  This Month
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item>---</Dropdown.Item>
                  <Dropdown.Item>---</Dropdown.Item>
                  <Dropdown.Item>---</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
            <div>
              <div className="dropdownTitle">Date Range</div>
              <Dropdown show={show} onToggle={() => setShow(!show)}>
                <Dropdown.Toggle
                  className="btnDropdownProduct"
                  id="dropdown-basic"
                >
                  {selectedLabel || "Select"}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu customDateMenu">
                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("7");
                    }}
                  >
                    Last 7 days
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("15");
                    }}
                  >
                    Last 15 days
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("30");
                    }}
                  >
                    Last 30 days
                  </Dropdown.Item>

                  <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                  <Dropdown.Item as="div" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="date"
                      className="form-control"
                      onChange={(e) => {
                        setShow(false); // close after selecting
                        setSelectedLabel(e.target.value);
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {selectedLabel && (
            <div className="filterResultsContainer mt-3">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          <div className="dashboardCardsPart">
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <RiMoneyRupeeCircleLine />
              </div>
              <div className="dashboardCardContent">
                <div>Total Sales (Retail)</div>
                <div>
                  ₹ {dashboardCards?.dashboard_card?.total_sales ?? "---"}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <FaCubes />
              </div>
              <div className="dashboardCardContent">
                <div>Current Stock Value</div>
                <div>
                  ₹{" "}
                  {dashboardCards?.dashboard_card?.current_stock_value ?? "---"}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <RiHandCoinLine />
              </div>
              <div className="dashboardCardContent">
                <div>Outstanding Dues</div>
                <div>
                  ₹{" "}
                  {dashboardCards?.dashboard_card?.outstanding_dues ??
                    "---"}{" "}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <MdOutlinePendingActions />
              </div>
              <div className="dashboardCardContent">
                <div>Pending Orders</div>
                <div>
                  {dashboardCards?.dashboard_card?.pending_orders ?? "---"}
                </div>
              </div>
            </div>
          </div>

          {/* sales chart  */}
          <div className="titleOrderList">Sales Overview</div>
          <div className="salesChartContainer">
            <div
              className="chart-width"
              style={{ height: "300px", width: "100%" }}
            >
              <Bar data={data} options={options} />
            </div>
          </div>
          {/* order list  */}
          <div className="titleOrderList">Orders List</div>
          {/* table 1  */}
          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell align="left">Order Date</TableCell>
                    <TableCell align="left">Sub-Distributor</TableCell>
                    <TableCell align="left">No. of Products</TableCell>
                    <TableCell align="left">Total Amount (₹)</TableCell>
                    <TableCell align="left">Payment type</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderList?.results?.length > 0 ? (
                    orderList?.results?.map((row) => (
                      <TableRow
                        key={row.order_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell component="th" scope="row">
                          {row.order_id ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.order_date ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.sub_distributor}
                        </TableCell>
                        <TableCell align="left">
                          {row.no_of_products ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.total_amount ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.payment_type ?? "---"}
                        </TableCell>

                        <TableCell
                          align="left"
                          style={{
                            color: (() => {
                              switch (row.status) {
                                case "Pending":
                                  return "#EF4444";
                                case "Approved":
                                  return "#45614C";
                                // case "Dispatched":
                                //   return "#F59E0B";
                                // case "Delivered":
                                //   return "#10B981";
                                default:
                                  return "var(--color-font-secondary)";
                              }
                            })(),
                          }}
                        >
                          {row.status ?? "---"}
                        </TableCell>

                        <TableCell align="left">
                          {row.status === "Pending" ? (
                            <button
                              className="btnTableManage"
                              onClick={() =>
                                navigate("/state-orders-manage", {
                                  state: { Id: row.order_id },
                                })
                              }
                            >
                              Manage
                            </button>
                          ) : (
                            <button
                              className="btnTableView"
                              onClick={() =>
                                navigate("/state-invoice-view", {
                                  state: { Id: row.invoice_id },
                                })
                              }
                            >
                              View
                            </button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        No orders available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
          {/* payment and dues table  */}
          <div className="titleOrderList">Payments & Dues</div>
          {/* table 2  */}

          <div className="dashboardTableContainer mt-4">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Source</TableCell>
                    <TableCell align="left">Counterparty</TableCell>
                    <TableCell align="left">Invoice</TableCell>
                    <TableCell align="left">Order Value</TableCell>
                    <TableCell align="left">Paid</TableCell>
                    <TableCell align="left">Balance Amount</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                {/* <TableBody>
                  {rows2.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      className="dashboardTableBody"
                    >
                      <TableCell component="th" scope="row">
                        {row.date}
                      </TableCell>
                      <TableCell align="left">{row.source}</TableCell>
                      <TableCell align="left">{row.countryParty}</TableCell>
                      <TableCell align="left">{row.invoice}</TableCell>
                      <TableCell align="left">{row.ordervalue}</TableCell>
                      <TableCell align="left">{row.paid}</TableCell>
                      <TableCell align="left">{row.balaceAmount}</TableCell>

                      <TableCell
                        align="left"
                        style={{
                          color: (() => {
                            switch (row.status) {
                              case "Overdue":
                                return "#EF4444";

                              case "Pending":
                                return "#F59E0B";
                              case "Paid":
                                return "#10B981";
                              default:
                                return "var(--color-font-secondary)";
                            }
                          })(),
                        }}
                      >
                        {row.status}
                      </TableCell>

                      <TableCell align="left">
                        <IoEyeOutline
                          onClick={() => navigate("/state-view-paymentsDues")}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody> */}
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      Data Not Available
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* table 3 and table 4  */}
          <div className="dashboardTableGrid">
            <div>
              <div className="titleOrderList">Low Stock Products</div>
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Current Qty</TableCell>
                      <TableCell align="left">Reorder Level</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {lowStockProducts?.results?.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">
                          {row.product_name ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.current_stock ?? "---"} {row.uom ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.reorder ?? "---"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={lowTotalCount}
                page={lowPage}
                onPageChange={(event, newPage) => setLowPage(newPage)}
                rowsPerPage={lowRowsPerPage}
                onRowsPerPageChange={handleLowRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>

            <div>
              <div className="titleOrderList">Fast-Moving Products</div>

              <TableContainer component={Paper} sx={{ maxHeight: 320 }}>
                <Table
                  // sx={{ minWidth: 650 }}

                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Sales Qty</TableCell>
                      <TableCell align="left">Sales Value (₹)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fastMovingData?.map((row) => (
                      <TableRow
                        key={row.product_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">
                          {row.product_name ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.salesQty ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          ₹ {row.total_sold ?? "---"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
